import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import CurrencyItem from '../../../../components/CurrencyItem';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';

import './CardWithdrawalAsset.scss';

const { routes } = AppConfig;

const CardWithdrawalAsset = () => {
	const [storedCardId, setStoredCardId] = useState();

	const cardsList = useSelector(state => state.card.cardsList);

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const cardId = storedCardId || Number(searchParams.get('cardId'));
	const card = cardsList.find(card => card.Id === cardId);

	const assets = card.Addresses.map(address => ({
		Id: address.CurrencyId,
		Amount: address.Amount,
		AmountUsd: address.AmountUsd,
	}));

	useEffect(() => {
		setStoredCardId(cardId);
	}, []);

	const selectAsset = asset => {
		navigate({
			pathname: routes.cardWithdrawalAccount,
			search: createSearchParams({ cardId, assetId: asset.Id }).toString(),
		});
	};

	return (
		<div className='CardWithdrawalAsset'>
			<PageHeader header={'Select asset to withdrawal'} />
			<div className='CardWithdrawalAsset__body FormBlock'>
				{assets.map((currency, index) => (
					<CurrencyItem key={index} currency={currency} onClick={selectAsset} />
				))}
			</div>
		</div>
	);
};

export default CardWithdrawalAsset;
